<template>
  <v-row class="d-flex mx-0 pt-3 align-center">
    <div class="px-0 d-flex justify-start py-3">
      <v-avatar size="50" color="white">
        <v-img
          class="object-cover"
          :src="$connection + author.photoURL"
          :alt="author.name"
        >
          <template v-slot:placeholder>
            <v-row
              class="fill-height ma-0 grey lighten-2"
              align="center"
              justify="center"
            >
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </v-avatar>
      <div class="ml-3">
        <div class="text-subtitle-2 grey--text text--darken-3">
          {{ author.name }}
        </div>
        <div class="text-subtitle-2 grey--text text--darken-3">
          Artikel Nr. {{ article_count }}
        </div>
      </div>
    </div>
    <v-spacer></v-spacer>
    <v-spacer></v-spacer>
    <v-spacer></v-spacer>
    <div
      class="align-self-center"
      :class="$route.path.includes('beitrag') ? 'grow' : 'mr-4'"
    >
      <v-btn
        v-if="$route.path.includes('beitrag') && !$vuetify.breakpoint.xs"
        color="primary"
        @click="$store.dispatch('publicApi/likePost', post._id)"
        elevation="3"
        :disabled="postsLiked.filter((p) => p._id === post._id).length === 1"
        tile
        outlined
        class="text-capitalize w-full"
        style="max-width: 400px"
      >
        <div>{{ $t("nice_article") }}</div>
        <v-icon class="ml-2" small>mdi-thumb-up</v-icon>
      </v-btn>
      <v-tooltip nudge-left="150" v-else top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            color="primary"
            elevation="2"
            icon
            :disabled="postsLiked.filter((p) => p._id === post._id).length === 1"
            tile
            @click="$store.dispatch('publicApi/likePost', post._id)"
            outlined
            class="text-capitalize align-self-start"
            style="max-width: 400px"
          >
            <v-icon :class="$route.path.includes('beitrag') && !$vuetify.breakpoint.xs ? 'ml-2' : ''" small
              >mdi-thumb-up</v-icon
            >
          </v-btn>
        </template>
        <span>{{ $t("like_what_you_see") }}</span>
      </v-tooltip>
    </div>
    <!-- <v-col cols="12">
      <Tags :tags="author.tags" />
    </v-col>-->
  </v-row>
</template>

<script>
// import Tags from "@/components/Tags";
export default {
  components: {
    // Tags
  },
  computed: {
    postsLiked() {
      return this.$store.getters["publicApi/getPostsLiked"];
    },
    user() {
return this.$store.getters["user/getUser"]
    }
  },
  props: ["author", "article_count", "post"],
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box !important;
}
</style>